module.exports = __webpack_public_path__ + "img/parking.ce7ce42e.png";